import { Track, makeFrame } from '@voidline/shared';

/**
 * Shared prop-placement helpers for bespoke environments: a coarse sample of the
 * track ribbon so builders can keep scenery clear of the racing surface.
 */

export interface RibbonInfo {
  ring: { x: number; y: number; z: number }[];
  cx: number;
  cy: number;
  cz: number;
  minY: number;
  maxY: number;
  /** Max horizontal distance of any ribbon sample from the centroid. */
  maxR: number;
}

export function sampleRibbon(track: Track, samples = 80): RibbonInfo {
  const frame = makeFrame();
  const ring: { x: number; y: number; z: number }[] = [];
  let cx = 0, cy = 0, cz = 0, minY = Infinity, maxY = -Infinity;
  for (let i = 0; i < samples; i++) {
    track.main.frameAt((i / samples) * track.length, frame);
    ring.push({ x: frame.pos.x, y: frame.pos.y, z: frame.pos.z });
    cx += frame.pos.x;
    cy += frame.pos.y;
    cz += frame.pos.z;
    minY = Math.min(minY, frame.pos.y);
    maxY = Math.max(maxY, frame.pos.y);
  }
  cx /= samples;
  cy /= samples;
  cz /= samples;
  let maxR = 0;
  for (const p of ring) maxR = Math.max(maxR, Math.hypot(p.x - cx, p.z - cz));
  return { ring, cx, cy, cz, minY, maxY, maxR };
}

/** True when (x, z) keeps at least `dist` horizontal clearance from every ribbon sample. */
export function clearOfRibbon(info: RibbonInfo, x: number, z: number, dist: number): boolean {
  for (const p of info.ring) {
    if (Math.hypot(p.x - x, p.z - z) < dist) return false;
  }
  return true;
}
